import React from 'react';
import {
  Image, Source, type ImageProps,
} from '@unpic/react';
import { graphql } from 'gatsby';

/** @knipignore */
export const query = graphql`
  fragment ContentfulCardImage on ContentfulAsset {
    title
    url
  }
`;

const BREAKPOINTS = [220, 290, 360, 412, 535];

type CardImage = Pick<ImageProps, 'priority' | 'alt' | 'src' | 'aspectRatio'>;

const ContentfulCardImage = ({
  src,
  priority = false,
  alt,
  aspectRatio = 1,
}: CardImage) => (
  <picture>
    {['avif', 'webp', null].map((format) => (
      <Source
        key={format || 'default'}
        src={`${src}?fm=${format || ''}`}
        type={format && `image/${format}`}
        breakpoints={BREAKPOINTS}
        layout="fullWidth"
        aspectRatio={aspectRatio}
      />
    ))}
    <Image
      aspectRatio={aspectRatio}
      layout="fullWidth"
      src={src}
      alt={alt}
      breakpoints={BREAKPOINTS}
      priority={priority}
    />
  </picture>
);

export default ContentfulCardImage;
